import './App.css';
import React from "react";
import { Routes, Route } from 'react-router-dom';
import PhotoSite from './container/photoSite/photoSite';
import Portfolio from './container/portfolio/portfolio';

function App() {
  return (
    <div className="App">
      <Routes>
          <Route path='/' element={<Portfolio />} />
          <Route path='/photoSite' element={<PhotoSite />} />
          <Route path='/portfolio' element={<Portfolio />} />
      </Routes>
    </div>
  );
}

export default App;
